import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

export default function MobileNavItem({ link, currentPageName, createPageUrl, onClose }) {
  const [expanded, setExpanded] = useState(false);

  if (!link.children) {
    return (
      <Link
        to={createPageUrl(link.page)}
        className={`block py-3 text-sm font-medium transition-colors ${
          currentPageName === link.page ? 'text-purple-600' : 'text-gray-700 hover:text-purple-600'
        }`}
        onClick={onClose}
      >
        {link.name}
      </Link>
    );
  }

  return (
    <div>
      <div className="flex items-center">
        {link.page ? (
          <Link
            to={createPageUrl(link.page)}
            onClick={onClose}
            className={`flex-1 py-3 text-sm font-medium transition-colors ${
              currentPageName === link.page ? 'text-purple-600' : 'text-gray-700 hover:text-purple-600'
            }`}
          >
            {link.name}
          </Link>
        ) : (
          <span className="flex-1 py-3 text-sm font-medium text-gray-700">
            {link.name}
          </span>
        )}
        <button
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setExpanded(!expanded); }}
          className="p-3 text-gray-400 hover:text-purple-600 transition-colors min-w-[48px] min-h-[48px] flex items-center justify-center"
        >
          <ChevronDown className={`w-4 h-4 transition-transform ${expanded ? 'rotate-180' : ''}`} />
        </button>
      </div>
      {expanded && (
        <div className="ml-4 border-l-2 border-purple-100 pl-4 pb-1">
          {link.children.map((child) => (
            <Link
              key={child.page}
              to={child.page}
              className="block py-2 text-sm text-gray-600 hover:text-purple-600 transition-colors"
              onClick={onClose}
            >
              {child.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}